import React, { useMemo } from 'react';

import {
  Select as AntSelect,
  type RefSelectProps,
  type SelectProps,
} from 'antd-v5';
import cn from 'classnames';

import styles from '../scss/_select.scss';

interface ComponentProps extends SelectProps {
  className?: string;
  minWidth?: React.CSSProperties['minWidth'];
  /** Sets default width to 100% */
  block?: boolean;
}

const Select: React.FC<ComponentProps> = React.forwardRef<
  RefSelectProps,
  ComponentProps
>(function Select(props, ref) {
  const {
    className,
    minWidth = '290px',
    block = true,
    ...componentProps
  } = props;

  const style = useMemo(() => {
    const defaultStyle = {
      ['--select-min-width']: minWidth,
    };
    const style = { ...defaultStyle, ...(componentProps.style || {}) };
    return style;
  }, [componentProps.style, minWidth]);

  return (
    <div
      className={cn(styles.container, {
        [styles.block]: !!block,
      })}
      style={style}
    >
      <AntSelect
        className={cn(className, {
          [styles.selectElement]: true,
          [styles.block]: !!block,
        })}
        ref={ref}
        {...componentProps}
      />
      <label htmlFor={componentProps.id} className={styles.floatingLabel}>
        {componentProps.placeholder}
      </label>
    </div>
  );
});

const { Option } = AntSelect;

export { Option };

export default Select;
